module.exports = __webpack_public_path__ + "img/robot.c10c1aa6.png";